import { useEffect } from 'react';

export default function useViewportHeight() {
  useEffect(() => {
    const setVvh = () => {
      const h = window.visualViewport?.height ?? window.innerHeight;
      // store in CSS var (vvh = "visual viewport height")
      document.documentElement.style.setProperty('--vvh', `${h}px`);
    };
    setVvh();
    window.addEventListener('resize', setVvh);
    window.visualViewport?.addEventListener('resize', setVvh as any);
    return () => {
      window.removeEventListener('resize', setVvh);
      window.visualViewport?.removeEventListener('resize', setVvh as any);
    };
  }, []);
}
